// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LSPZ","tabsBox":"styles_tabsBox__1p5Zh","createButton":"styles_createButton__2Cmg-"};